export default __webpack_public_path__ + "static/media/disable.4a5fdcad.svg";